export const DEMO_EMAIL = 'demo@bcdinc.com';
